import { environment } from "../environment";
import { AsyncResult } from "../models/common/async-result";
import { Attendance, AttendanceSummary, AttendanceRecord } from "../models/attendance";
import api from "./api";

export async function getClubAttendanceSummary(clubId: number): Promise<AttendanceSummary[]> {
  const baseUrl = environment.api.attendance.getSummaryListByClubId
    .replace('{clubId}', String(clubId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function getAttendanceSummaryByMeetId(meetId: number, clubId: number): Promise<AttendanceSummary | undefined> {
  const baseUrl = environment.api.attendance.getAttendanceSummaryByMeetId
    .replace('{clubId}', String(clubId))
    .replace('{meetId}', String(meetId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function getAttendancesByMeetId(meetId: number, clubId: number): Promise<Attendance[]> {
  const baseUrl = environment.api.attendance.getAttendancesByMeetId
    .replace('{clubId}', String(clubId))
    .replace('{meetId}', String(meetId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}

export async function registerMeetAttendance(clubMembers: AttendanceRecord[], clubId: number, meetId: number): Promise<AsyncResult<number[]>> {
  const url = environment.api.attendance.registerMeetAttendance
    .replace('{clubId}', String(clubId))
    .replace('{meetId}', String(meetId));

  const response = await api.post(url, {clubMembers: clubMembers})
      .then(resp => resp?.data.success)
      .catch(() => null);

  if (!response) return { error: 'Erro ao registrar presenças na reunião!' }

  return { success: response };
}

export async function getAttendanceByUserAndMeet(userId: number, meetId: number, clubId: number): Promise<Attendance> {
  const baseUrl = environment.api.attendance.getByUserAndMeet
    .replace('{clubId}', String(clubId))
    .replace('{meetId}', String(meetId))
    .replace('{userId}', String(userId));
  
  return await api.get(baseUrl).then(res => res.data.success);
}